import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const BannerLink = styled("a")`
    color: ${({theme}) => theme.uxfabric.components.appBar.globalBar.default.textColor};
    text-decoration: none;
    font-size: ${({theme}) => theme.uxfabric.global.body4.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.global.body4.fontWeight};
    font-family: ${({theme}) => theme.uxfabric.global.body4.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
`
